import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CoreCommonModule} from '../../../../../../@core/common.module';
import {CoreDirectivesModule} from '../../../../../../@core/directives/directives';
import {SharedModule} from '../../../../shared/shared/shared.module';
import {UploadFilesModule} from '../../../../shared/upload-files/upload-files.module';
import {BulkUploadModule} from '../../../contract-control/modals/bulk-upload-modal/bulk-upload.module';
import {BulkUploadStepsModule} from '../../../contract-control/modals/bulk-upload-modal/steps/bulk-upload-steps.module';
import {DocumentsBulkUploadComponent} from './documents-bulk-upload/documents-bulk-upload.component';
import {documentsBulkUploadConfig} from './store/documents-bulk-upload.config';
import {DocumentsBulkUploadEffects} from './store/documents-bulk-upload.effects';
import {documentsBulkUploadReducer} from './store/documents-bulk-upload.reducers';


@NgModule({
    declarations: [
        DocumentsBulkUploadComponent
    ],
    imports: [CoreCommonModule, NgbModule, CommonModule, SharedModule, StoreModule.forFeature(documentsBulkUploadConfig, documentsBulkUploadReducer), EffectsModule.forFeature([DocumentsBulkUploadEffects]), CoreDirectivesModule, UploadFilesModule, BulkUploadStepsModule, BulkUploadModule, TranslocoDirective],
    exports: [
        DocumentsBulkUploadComponent
    ],

    providers: [
       
    ]

})
export class DocumentsBulkUploadModule {
}
